import detailDefault from '../../detailDefault';
export default class detailOpportunities extends detailDefault {
    load(sAction, data) {
        sAction.dsClear();
        const salesStage = sAction.dataGet(data.prefix+'/fields/sales_stage/value');
        if (salesStage === 'Closed Lost') {
            sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/readonly', false);
            sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/required', true);
            sAction.dsAdd('set', data.prefix+'/fields/pripominky_k_uzavreni_c/def/readonly', false);
        } else {
            if (salesStage === 'Closed Won') {
                sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/readonly', false);
                // sAction.dsAdd("set", data.prefix+"/fields/duvod_uzavreni_c/def/visible", false);
            } else {
                sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/readonly', true);
            }
            sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/required', false);
        }

        if (sAction.getModuleName() === 'Contacts' && data.prefix !== 'view') {
            const accData = sAction.dataGet('view/fields/account_name');
            const name = accData.get('value');
            const id = accData.getIn(['def', 'id_value']);
            if (id) {
                sAction.dsAdd('set', data.prefix+'/fields/account_name/value', name);
                sAction.dsAdd('set', data.prefix+'/fields/account_name/def/id_value', id);
                sAction.dsAdd('set', data.prefix+'/changes/fields/account_id', id);
            }
        }

        if (!sAction.dataGet(`${data.prefix}/fields/probability/value`)) {
            const probability = sAction.app_strings['sales_probability_dom'][salesStage];
            sAction.dsAdd('set', data.prefix+'/fields/probability/value', probability);
            sAction.dsAdd('set', data.prefix+'/changes/fields/probability', probability);
        }

        sAction.dsProcess();
    }

    update(sAction, data) {
        if (data.field === 'account_id') {
            const name = sAction.dataGet(data.prefix+'/fields/name/value');
            if (name === null || name === '') {
                const nameAcc = sAction.dataGet(data.prefix+'/fields/account_name/value');
                sAction.dsClear();
                sAction.dsAdd('set', data.prefix+'/fields/name/value', nameAcc);
                sAction.dsAdd('set', data.prefix+'/changes/fields/name', nameAcc);
                sAction.dsProcess();
            }
        } else if (data.field === 'sales_stage') {
            const probability = sAction.app_strings['sales_probability_dom'][data.value];
            sAction.dsClear();
            sAction.dsAdd('set', data.prefix+'/fields/probability/value', probability);
            sAction.dsAdd('set', data.prefix+'/changes/fields/probability', probability);
            if (data.value === 'Closed Lost') {
                sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/readonly', false);
                sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/required', true);
                sAction.dsAdd('set', data.prefix+'/fields/pripominky_k_uzavreni_c/def/readonly', false);
            } else {
                if (data.value === 'Closed Won') {
                    sAction.dsAdd('set', data.prefix+'/fields/pripominky_k_uzavreni_c/def/readonly', false);
                } else {
                    sAction.dsAdd('set', data.prefix+'/fields/pripominky_k_uzavreni_c/def/readonly', true);
                }
                sAction.dsAdd('set', data.prefix+'/fields/duvod_uzavreni_c/def/required', false);
            }
            sAction.dsProcess();
        }
    }
}
